import dataLayer from '@helpers/dataLayer';

export const quoteClickHelper = (contactUsForm: { I18: Record<string, string> }, redirect?: () => void) => {
  localStorage.setItem('CategoryID', contactUsForm.I18.CategoryID);
  // quoteOriginPageID is used as parent page id in contact-us/enquiry type form
  localStorage.setItem('quoteOriginPageID', window.pageId);
  localStorage.setItem('quoteOriginPageUrl', window.location.href);

  dataLayer.push('contact_button', {
    contact_type: contactUsForm?.I18?.RequestForQuote || '',
  });

  if (redirect) {
    redirect();
  } else {
    window.location.href = contactUsForm?.I18?.EnquiryTypeLink;
  }
};
